import { createAction, props } from "@ngrx/store";

export const setToolboxTalkSegment = createAction(
  "[ToolboxTalk Segment] Toolbox Talk Set Segment",
  props<{ segment: "topics" | "attendees" }>()
);
